<template>
  <div>
    <v-navigation-drawer disable-resize-watcher hide-overlay disable-route-watcher permanent width="auto" v-model="drawer" app color="#425058" style="max-width:320px; overflow-x:hidden; max-height: calc(100% - 0px); color: #fff;" class="raceDayNavigation">
      <div style="width:400px;"></div>
      <template v-slot:prepend>
        <div class="px-2" style="max-width: 100%; margin-top: 55px">
          <v-list class="pa-0" style="height: 38px;">
            <v-list-item class="pa-0">
              <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y min-width="0%" :nudge-right="40">
                <template v-slot:activator="{ on }">
                  <v-text-field dark class="formattedDate ml-n1" v-model="formattedDate" small prepend-icon="mdi-calendar" readonly v-on="on" style="font-size:14px;" hide-details=""></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable actions color="#425058">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <MeetingSummary :meetingSummaryToggle="meetingSummaryToggle" :closeSummary="closeMeetingSummary" :closeMeetingSummaryModal="closeMeetingSummaryModal"/>
              <RaceNavFilter :setFiltersOpen="setFiltersOpen" :openMeetingSummary="openMeetingSummary"/>
            </v-list-item>
          </v-list>
        </div>
      </template>
      <v-divider style="background: #fff;"></v-divider>
      <div v-if="getSilksErrorsLoading" style="padding-left: 10px;">
        <v-progress-circular
          indeterminate
          color="white"
          size="15"
          width="3"
        ></v-progress-circular><span class="white--text ml-2">Searching for silk errors</span>
      </div>
      <div style="background:#f44336; height:8px; width:8px; display:inline-block; margin-right:5px; border-radius:5px;" class="ml-2"></div>
      <div class="d-inline caption">Indicates silk errors</div>
      <div class="raceNavigation" style="font-weight:300;margin:0 auto;">
        <v-data-table dense overflow-y="hidden" :loading="sorted.length === 0" loading-text="Loading Races..." :items="sorted" :headers="headersRacesGroupByMeeting" hide-default-footer :items-per-page=9999 show-expand :expanded.sync="expanded" item-key="meetingName" :sort-by.sync="sortBy" :sort-desc="true">
          <template v-slot:header.data-table-expand>
            <button @click="closeAllExpanded"></button>
          </template>
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr @click="expand(!isExpanded)">
              <td class="tdRacesGroupByMeeting" style="padding-left: 10px !important;">
                <country-flag style="vertical-align: middle; transform: scale(0.3);" :country="item.meetingCountry" size="small" />
              </td>
              <td class="tdRacesGroupByMeeting">
                <img :src="raceTypeImg[item.meetingType]" style="max-width:20px" />
              </td>
              <td class="tdRacesGroupByMeeting" style="white-space: nowrap; text-overflow: ellipsis; max-width: 200px; padding-right:0px; overflow:hidden; margin-left:15px; font-weight: bold;">
                <div v-if="item.silksErrorIndicator" style="background:#f44336;height:8px;width:8px;display:inline-block;margin-right:5px;border-radius:5px;" title="Silk errors"></div>{{ item.meetingName }} ({{ item.Races.length }})
              </td>
              <td class="pa-1">
                <v-icon v-if="isExpanded">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-data-table dense overflow-y="hidden" class="raceDayTable" :loading="sorted.length === 0" loading-text="Loading Races..." :items="item.Races" hide-default-footer :items-per-page=9999 :header-props="{ sortIcon: null }">
                <template v-slot:item="{ item }">
                  <v-tooltip right nudge-bottom="40" nudge-left="70" z-index="999" color="black" open-delay="400">
                    <template v-slot:activator="{ on }">
                      <tr v-if="Object.keys(races).length !== 0" style="cursor:pointer" @click="clickRace(item)" :class="{selected:(highlightedRace == item.id)}" class="raceNavigationRow" v-on="on">
                        <td class="pa-1" style="font-size:0.8em">
                          {{formattedStartTime(item)}}
                        </td>
                        <td class="pa-1" style="max-width:20px;">
                          {{`R${item.number}`}}
                        </td>
                        <td style="white-space: nowrap; text-overflow: ellipsis; max-width:100px; padding-right:0px; overflow:hidden; margin-left:15px; padding: 0 5px;">
                          <div v-if="item.silksErrorIndicator" style="background:#f44336;height:8px;width:8px;display:inline-block;margin-right:5px;border-radius:5px;" title="Silk errors"></div>{{item.name}}
                        </td>
                        <td class="pa-1 raceDayTime" align="right" v-if="item.status == 'FINAL'" >
                          Final
                        </td>
                        <td class="pa-1 raceDayTime" align="right" v-if="item.status === 'CLOSED'"  style="color:red">
                          Closed
                        </td>
                        <td class="pa-1 raceDayTime" align="right" v-if="item.status === 'ABANDONED'"  style="color:red">
                          Abandoned
                        </td>
                        <td class="pa-1 raceDayTime" align="right" v-if="item.status === 'INTERIM'"  style="color:orange">
                          Interim
                        </td>
                        <td class="pa-1 raceDayTime"  align="right" v-else-if="item.status === 'OPEN'">
                          <Countdown :key="item.startTime" :startTime="item.startTime" :formattedStartTime="races[item.id].formattedStartTime"/>
                        </td>
                      </tr>
                    </template>
                    <span class="tooltiptextRaceNavigation caption"><pre class="tooltipTextRaceNavigationPreformatted">{{getHoverText(item)}}</pre></span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { startOfDay, format, getUnixTime, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import goTo from 'vuetify/es5/services/goto'
import MeetingSummary from './MeetingSummary'
import RaceNavFilter from './RaceNavFilter'
import Countdown from './Countdown'

export default {
  name: 'RaceDayNavigation',
  data: () => ({
    drawer: true,
    setRaceOnLoad: 0,
    meetingSummaryToggle: false,
    closeMeetingSummaryModal: false,
    clickedRace: null,
    raceTypeImg: {
      HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
      GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
      THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
    },
    headersRacesGroupByMeeting: [
      {
        value: 'meetingCountry',
        class: 'racesGroupByMeeting'
      },
      {
        value: 'meetingType',
        class: 'racesGroupByMeeting'
      },
      {
        value: 'meetingName',
        class: 'racesGroupByMeeting'
      },
      {
        text: 'Close',
        value: 'data-table-expand',
        class: 'racesGroupByMeeting'
      }
    ],
    menu: false,
    filtersOpen: false,
    expanded: [],
    sortBy: 'meetingType'
  }),
  components: {
    MeetingSummary,
    RaceNavFilter,
    Countdown
  },
  computed: {
    ...mapState(['selectedDate', 'selectedRace', 'races', 'selectRaceNavSet']),
    ...mapState('account', ['authorized']),
    ...mapGetters(['getRaces', 'getRacesGroupedByMeeting', 'getSilksErrorsLoading']),
    highlightedRace: function () {
      return this.clickedRace || this.selectedRace.id
    },
    sorted: function () {
      return this.getRacesGroupedByMeeting
    },
    date: {
      get () {
        const d = format(this.selectedDate, 'yyyy-MM-dd')
        return d
      },
      async set (n) {
        await this.setDate(utcToZonedTime(new Date(n)))
      }
    },
    formattedDate () {
      return format(this.selectedDate, 'MMM d, yyyy')
    },
    selectedNextRaceScroll () {
      return (`${this.setRaceOnLoad}`)
    }
  },
  async created () {
    // Select the next race to go on mount
    await this.setDate(startOfDay(Date.now()))
    await this.fetchMeetingSummaryRaces()
    // await this.racesGroupedByMeeting()
    const r = this.getNextToGo
    if (r) {
      this.selectRace({ id: r.id, idChanged: true })
    }
    this.setThisRaceOnLoad(1)
    setInterval(() => {
      this.updateClocks()
    }, 1000)
  },
  watch: {
    selectedNextRaceScroll: function () {
      if (this.setRaceOnLoad !== 0) {
        try {
          goTo('.raceNavigation .selected', { container: this.$el.querySelector('.v-navigation-drawer__content'), offset: 0 })
        } catch {
          //
        }
      }
    },
    selectRaceNavSet (v) {
      if (v !== 0) {
        this.setThisRaceOnLoad(1)
        this.selectRaceNav(0)
      }
      return null
    },
    selectedRace: function (newRace, oldRace) {
      if (newRace.id !== oldRace.id) {
        this.clickedRace = null
      }
    }
  },
  methods: {
    ...mapActions(['selectRace', 'selectRaceNav', 'setDate', 'fetchMeetingSummaryRaces', 'updateClocks', 'racesGroupedByMeeting']),
    closeAllExpanded () {
      this.expanded = []
    },
    openMeetingSummary () {
      this.meetingSummaryToggle = true
    },
    closeMeetingSummary () {
      this.meetingSummaryToggle = false
      this.closeMeetingSummaryModal = false
    },
    setThisRaceOnLoad (value) {
      const races = this.getRaces
      const racesLoad = Object.keys(races).length
      if (racesLoad !== 0) {
        setTimeout(() => {
          this.setRaceOnLoad = value
        }, 1000)
        this.setRaceOnLoad = 0
      } else {
        setTimeout(() => {
          this.setThisRaceOnLoad()
        }, 3000)
      }
    },
    formattedStartTime: function (x) {
      return format(parseISO(x.startTime), 'HH:mm')
    },
    async clickRace (v) {
      this.clickedRace = v.id
      this.selectRace({
        id: v.id,
        idChanged: true
      })
    },
    getUnixTime,
    getHoverText (item) {
      return `R${item.number} ${item.meeting.track.name} - ${item.name} \nDist: ${item.distance} | Cond: ${item.trackCondition}`
    },
    setFiltersOpen (state) {
      this.filtersOpen = state
    }
  }
}
</script>

<style scoped>
.raceNavigation {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Safari */
  -khtml-user-select: none;    /* Konqueror HTML */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;           /* Non-prefixed version, currently supported by Chrome and Opera */
}
.raceDayTime {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:55px;
}
.raceDayNavigation {
  z-index: 5;
  padding-bottom:30px;
}
.selected {
  background: #4caf50;
}
.v-data-table__wrapper .raceDayTable {
  overflow-x: hidden;
}
.v-navigation-drawer__border {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 0px;
}
.v-data-table table {
    min-width: 100%;
    border-spacing: 0;
}
.tooltipTextRaceNavigationPreformatted {
  font-family: 'Roboto', sans-serif;
}
.raceDayTable tbody td:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0);
}
.v-input__icon--prepend .v-icon {
  font-size: 16px;
}
.v-input__prepend-outer{
    margin-right: 0px !important;
}
.ma-1 {
  padding: 0 2.8888888889px !important;
}
.formattedDate {
  padding-top: 0px;
  margin-top: 0px;
}
label {
  height: 10px;
}
.v-input__slot {
  align-items: center;
  justify-content: center;
}
.racesGroupByMeeting .v-data-table-header__icon {
  opacity: 1;
}
.tdRacesGroupByMeeting {
  padding: 0px 3px !important;
}
.v-text-field input {
  padding: 0 !important;
}
.v-input__append-outer, .v-input__prepend-outer {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.v-navigation-drawer__content {
  margin-top: 10px;
}
.formattedDate input {
  color: white !important;
}
.v-input__icon--prepend .v-icon {
  color: white !important;
}
.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff !important;
}

</style>
